<div class="component-viewer">
    <h2>Sponsor Details</h2>
    <mat-card>
        <mat-card-content>
            <div class="container-fluid">
                <div class="row">
                    <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
                </div>
                <div class="row mb-4">
                    <div class="col-12">
                        <div>Name</div>
                    </div>
                    <div class="col-12">
                        <div>{{sponsor?.name}}</div>
                    </div>
                </div>
                <div class="row mb-4">
                    <div class="col-12">
                        <div>Company</div>
                    </div>
                    <div class="col-12">
                        <div>{{sponsor?.company}}</div>
                    </div>
                </div>
                <div class="row mb-4">
                    <div class="col-12">
                        <div>Contact Email</div>
                    </div>
                    <div class="col-12">
                        <div>{{sponsor?.contactEmail}}</div>
                    </div>
                </div>
                <div class="row mb-4">
                    <div class="col-12">
                        <div>Request Receipt</div>
                    </div>
                    <div class="col-12">
                        <yes-no [value]="sponsor.requestReceipt"></yes-no>
                    </div>
                </div>
                <div class="row mb-4">
                    <div class="col-12">
                        <div>Amount</div>
                    </div>
                    <div class="col-12">
                        <div>${{sponsor?.amount}}</div>
                    </div>
                </div>
                <div class="row mb-4">
                    <div class="col-12">
                        <div>Sponsor Type</div>
                    </div>
                    <div class="col-12">
                        <div>
                            <ng-container *ngIf="sponsor?.type == 1">Hole Sponsor</ng-container>
                            <ng-container *ngIf="sponsor?.type == 2">Cart Sponsor</ng-container>
                            <ng-container *ngIf="sponsor?.type == 3">Donation</ng-container>
                            <ng-container *ngIf="sponsor?.type == 4">Team</ng-container>
                            <ng-container *ngIf="sponsor?.type == 5">Other</ng-container>
                        </div>
                    </div>
                </div>
                <div class="row mb-4">
                    <div class="col-12">
                        <div>Notes</div>
                    </div>
                    <div class="col-12">
                        <div>{{sponsor?.notes}}</div>
                    </div>
                </div>
            </div>
        </mat-card-content>
        <mat-card-actions>
            <button mat-raised-button [routerLink]="['../../../sponsor/edit/', id]">
                Edit <mat-icon>edit</mat-icon>
            </button>
        </mat-card-actions>
    </mat-card>
</div>